import apiClient from '../api/axios';

/**
 * Асинхронно запрашивает защищенный файл с бэкенда и возвращает локальный Blob URL.
 * @param {string} fullPath - Полный путь к файлу, как он приходит от API (например, /uploads/songs/file.mp3).
 * @param {string} disposition - 'inline' для просмотра или 'attachment' для скачивания.
 * @returns {Promise<string>} - Промис, который разрешается в Blob URL.
 */
export const getSecureFileUrl = async (fullPath, disposition = 'attachment') => {
  // Удаляем возможный ведущий слэш и префикс /uploads/ из пути,
  // чтобы получить относительный путь для нашего нового эндпоинта.
  const relativePath = fullPath.startsWith('/') ? fullPath.substring(1) : fullPath;
  const cleanPath = relativePath.startsWith('uploads/') ? relativePath.substring(8) : relativePath;

  try {
    const response = await apiClient.get(`/v1/media/${cleanPath}?disposition=${disposition}`,
      {
        responseType: 'blob',
      }
    );
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const url = URL.createObjectURL(blob);
    return url;
  } catch (error) {
    console.error('Error fetching secure file:', error);
    // В случае ошибки можно вернуть пустую строку или специальное значение,
    // чтобы компонент-потребитель мог обработать ошибку.
    return '';
  }
};
